module.exports = __webpack_public_path__ + "img/close-button.5aac0d59.svg";